module.exports = __webpack_public_path__ + "static/media/email.0a8cecd6.svg";